import React from 'react';
import './iframe-page.scss';

interface IframePageProps {
    url: string;
}

const IframePage: React.FC<IframePageProps> = ({ url }) => {
    return (
        <div className="iframe-page">
            <div className="iframe-page-content">
                <iframe
                    src={url}
                    className="iframe-page-iframe"
                    title="Store Front Localization"
                />
            </div>
        </div>
    );
};

export default IframePage;
